import { render, staticRenderFns } from "./OrcamentoServicoTabela.vue?vue&type=template&id=efd23268&scoped=true"
import script from "./OrcamentoServicoTabela.vue?vue&type=script&lang=js"
export * from "./OrcamentoServicoTabela.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoServicoTabela.vue?vue&type=style&index=0&id=efd23268&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd23268",
  null
  
)

export default component.exports